<nz-form-item>
  <div style="padding: 6px">
    <span [ngClass]="labelClass" [class.required-label]="required">{{ label }}</span>
    @if (secondLabel) {
    <span [class]="secondLabelClass" style="margin-left: 4px">{{ secondLabel }}</span>
    }
  </div>
  <nz-select
    nzShowSearch
    [formControl]="asFormControl(inputFormControl)"
    (nzOnSearch)="onSearch($event)"
    [nzMode]="multiple ? 'multiple' : 'default'"
    [nzPlaceHolder]="placeHolder"
    [nzLoading]="loading"
    [nzNotFoundContent]="textContent"
    [nzAllowClear]="allowClear"
    [nzDropdownRender]="renderTemplate"
    (nzScrollToBottom)="loadMore()"
    [nzDisabled]="selectorDisabled"
    [nzServerSearch]="!filterDropdown"
  >
    @for (select of selects; track trackBySelect($index, select)) {
    <nz-option [nzLabel]="labelAndLabelFuncSelect(select)" [nzValue]="select[valueSelect]" [nzDisabled]="select[disabledSelect]" [nzCustomContent]="select[tooltipSelect]">
      <div nz-tooltip [nzTooltipPlacement]="['topLeft', 'leftTop']" [nzTooltipTitle]="select[tooltipSelect]">{{ labelAndLabelFuncSelect(select) }}</div>
    </nz-option>
    }
  </nz-select>
  <ng-template #renderTemplate>
    @if (loading) {
    <nz-spin></nz-spin>
    }
  </ng-template>
  <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
</nz-form-item>
